import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

import Personal from "./components/page/Personal";
import Manager from "./components/page/Manager";
import Shareholder from "./components/page/Shareholder";
import MixCharts from "./components/page/MixChart";

//import Controls from "./components/controls";
import { BasicContext } from './context/BasicContext'
import WebServiceContext from "./webService/WebServiceContext";



let sURL = new URL(window.location.href);

export default () => {
    const bc = useContext(BasicContext)
    const ws = useContext(WebServiceContext)
  
   const [open, setOpen] = useState<boolean>(false)
   
    useEffect(()=>{
        
        if(sURL.searchParams.get('pid') != null){
            bc.setPID(sURL.searchParams.get('pid') as string)
        }
        ws.webservice.asyncMenuChecker().then(res=>{
            const resData:MenuButtonProps[] = res as MenuButtonProps[]            
            
            let mdata:MenuButtonProps[] = [
                {txt:"個人", BID:"Personal", TabName:"個人", TabOrd:0},
                //{txt:"處經理", BID:"Manager"},
                //{txt:"事業體", BID:"Shareholder"}
            ]
            

            resData.map((rd:MenuButtonProps)=>{
                
                let chk:boolean = false
                /*
                mdata.map((md:MenuButtonProps)=>{
                    if(md.TabName == rd.TabName){
                        chk = true
                        //mdata.push({txt:"綜合圖表", BID:"MixCharts"})
                    }
                }) 
                */
                for(let md of mdata){
                    if(md.txt == rd.TabName){
                        chk = true
                        break;
                    }
                }
                if(!chk){
                    const bid:string  =
                        rd.TabName == "事業體" ? "Shareholder":
                        rd.TabName == "處經理" ? "Manager":
                        rd.TabName == "綜合圖表" ? "MixCharts":
                        ""
                     
                    mdata.push({
                        txt:rd.TabName,
                        BID:bid,
                        TabName:rd.TabName,
                        TabOrd:rd.TabOrd})
                }
                //console.log(mdata)
                mdata.sort((a, b)=>{  
                    if (a.TabOrd > b.TabOrd) return 1;
                    if (a.TabOrd < b.TabOrd) return -1;
                    return 0;
                })
            })
            /*
            if(c.length > 0){
                mdata.push({txt:"綜合圖表", BID:"MixCharts"})
            }
            */
            bc.setMenuData(mdata)
            setOpen(true)
        })
        return
    },[])
    
    useEffect(()=>{
        /*
        if(bc.PID !="" && bc.PID !="Personal" ){
            const Gid:string = bc.PID;
            ws.webservice.asyncPageContent(Gid).then(res=>{
              
                bc.setPageContents(res as PageContentProps[])

                console.log(Gid)
            })
        }*/
        return
    },[bc.PID])


    return (
        <>
        {
            open &&
                bc.PID == "Personal"?
                <Personal />:
                bc.PID == "Manager"?
                <Manager tabName="處經理"/>:
                bc.PID == "Shareholder"?
                <Manager tabName="事業體"/>:
                //<Shareholder/>:
                bc.PID == "MixCharts"?
                <MixCharts tabName="綜合圖表"/>:
                /*
                bc.PID == "16468"?//E管家綁定
                <HibLine />:
                bc.PID == "16471"?//活動報到率
                <Events />:
                bc.PID == "16470"?//行動保
                <Mob />:
                */
                "Loading..."
        }
        </>
    )

};
